module.exports = __webpack_public_path__ + "static_pc/img/af3.f02e17a9.png";